export default __webpack_public_path__ + "static/media/illus04.a96ac7f5.png";